export const getCompetitionSlug = (competitionName: string) => {
  return competitionName
    ?.toLocaleLowerCase()
    .replace(/[^a-z0-9]/g, " ")
    .replace(/ +/g, " ")
    .trim()
    .split(" ")
    .join("-");
};
